import styles from '../Components/styles/InventoryOverviewPopup.module.scss';
import { Label, Icon, Popup, Button } from 'semantic-ui-react';
import PersonPopupContent from './PersonPopupContent';
import { PersonDTO } from '@behavior/inventories/dto/PersonDTO';
import { LabelDetail } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

type Props = {
  contact: PersonDTO;
  closeIcon?: boolean;
  onDelete?: () => void;
  showPersonalData?: boolean;
  showWarning?: boolean;
  role?: string;
  showWarningIfPersonNotAtCern?: boolean;
};

const PersonPopup = ({
  contact,
  showPersonalData,
  closeIcon,
  onDelete,
  showWarning,
  role,
  showWarningIfPersonNotAtCern,
}: Props) => {
  const labelClass = closeIcon
    ? `${styles.contact} ${styles.labelText} mouseCursorPointer labelContact`
    : `${styles.contactWithoutDelete} ${styles.labelTextWihoutDelete} mouseCursorPointer`;

  const labelWarningClass = showWarning
    ? ' labelPersonPopupWarning'
    : showWarningIfPersonNotAtCern && contact.atCern === 'N'
    ? ' labelPersonPopupNotAtCern'
    : ' labelPersonPopup';
  const roleClass = role ? ' rolePersonPopup ' : '';
  const { t } = useTranslation();

  return (
    <Popup
      key={contact.id}
      on="click"
      pinned
      trigger={
        <Label className={`${labelClass}${labelWarningClass}${roleClass}`}>
          {role && <LabelDetail>{role}</LabelDetail>}
          {showWarning && (
            <Popup
              trigger={<Icon name="warning sign" className="warningIconExpiredCompetency" />}
              on={['hover']}
              size="mini"
              content={t('message.person.missing.competencies')}
            />
          )}
          <div className="personNameWithIcon">
            {showWarningIfPersonNotAtCern && contact.atCern === 'N' && (
              <Popup
                trigger={<Icon name="warning sign" className="warningIconNotAtCern" />}
                on={['hover']}
                size="mini"
                content={t('message.person.not.present.at.cern')}
              />
            )}
            <div>
              {showPersonalData
                ? contact.name
                : closeIcon
                ? contact.name
                : contact.name.replace(/[a-z]/g, 'x')}
            </div>

            <Icon className={closeIcon ? styles.iconCL : styles.icon} name="user" />
          </div>
          {closeIcon && (
            <Icon className={styles.iconCL} name="remove" color="blue" onClick={onDelete} />
          )}
        </Label>
      }
      content={<PersonPopupContent contact={contact} showPersonalData={showPersonalData} />}
      size="mini"
      className={styles.personPopup}
    />
  );
};

PersonPopup.deafaultProps = {
  showWarning: false,
  showWarningIfPersonNotAtCern: false,
};

export default PersonPopup;
